import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  mobileGlassCard,
  mobileGlassCardAndroid,
  authMobileTitleSx,
  authMobileSubtitleSx,
  authMobileBackButtonSx,
} from './loginDarkTheme';
import { getNativePlatform } from '../../utils/mobileView';

export default function AuthMobileCard({
  title,
  subtitle,
  children,
  onBack,
  backDisabled = false,
}) {
  const hasHeader = Boolean(title || subtitle || onBack);
  const cardSx = getNativePlatform() === 'android' ? mobileGlassCardAndroid : mobileGlassCard;

  return (
    <Box sx={cardSx}>
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        {hasHeader ? (
          <Box sx={{ mb: subtitle ? 0 : 2, minHeight: onBack ? 40 : undefined }}>
            {onBack ? (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '40px 1fr 40px',
                  alignItems: 'center',
                  columnGap: 0.5,
                  mb: subtitle ? 0.75 : 0,
                }}
              >
                <IconButton
                  onClick={onBack}
                  disabled={backDisabled}
                  aria-label="Go back"
                  sx={authMobileBackButtonSx}
                >
                  <ArrowBackIcon sx={{ fontSize: 20 }} />
                </IconButton>
                {title ? (
                  <Typography component="h1" variant="h6" sx={{ ...authMobileTitleSx, mb: 0, textAlign: 'center' }}>
                    {title}
                  </Typography>
                ) : (
                  <Box />
                )}
                <Box aria-hidden="true" />
              </Box>
            ) : (
              title ? (
                <Typography component="h1" variant="h6" sx={authMobileTitleSx}>
                  {title}
                </Typography>
              ) : null
            )}
            {subtitle ? (
              <Typography
                variant="body2"
                sx={{ ...authMobileSubtitleSx, textAlign: onBack ? 'center' : undefined }}
              >
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        ) : null}
        {children}
      </Box>
    </Box>
  );
}
